import script from "./new-edit-task-templates-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-edit-task-templates-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__